module.exports = __webpack_public_path__ + "6a4f533f788b909dc0d9467bc48300ff.png";